import { Component, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { TranslationService, I18nModule } from '@spartacus/core';
import { CustomProductsService } from '../custom-products/custom-products.service';
import { pairwise, tap } from 'rxjs/operators';
import moment from 'moment';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { BehaviorSubject } from 'rxjs';
import { Title } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { VesselNominationModalComponent } from 'src/app/shared/components/vessel-nomination-modal/vessel-nomination-modal.component';
import { CustomLoginService } from '../../custom-login/custom-login-form/custom-login.service';
import { CsAgentAuthService } from '@spartacus/asm/root';
import { CommonPageBreadcrumbsComponent } from '../../../shared/components/common-page-breadcrumbs/common-page-breadcrumbs.component';
import { ShipmentFilterBarComponent } from './shipment-filter-bar/shipment-filter-bar.component';
import { FormsModule } from '@angular/forms';
import { NgIf, NgFor, DecimalPipe } from '@angular/common';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
@Component({
    selector: 'app-shipment',
    templateUrl: './shipment.component.html',
    styleUrls: ['./shipment.component.scss'],
    imports: [CommonPageBreadcrumbsComponent, ShipmentFilterBarComponent, FormsModule, NgIf, InfiniteScrollDirective, NgFor, DecimalPipe, I18nModule]
})
export class ShipmentComponent implements OnInit, OnDestroy {
  // Title='BHP Connect - Shipments & documents';
  title: any;
  navigationData: string;
  shipmentPageData: any;
  shipmentProductEntriesData: [];
  enableLoader: boolean = true;
  fromDate: string = null;
  toDate: string = null;
  status: string = null;
  product: string = null;
  errorMessage: any;
  searchText: string = null;
  startDate: string = null
  endDate: string = null
  commodity: any;
  reachedToEnd: boolean = false;
  page = 0;
  activeTab = 'upcoming';
  shipmentTab = 'UPCOMING';
  listSrc = '/images/list-view-orange.svg';
  gridSrc = '/images/grid-view.svg';
  list = true;
  grid = false;
  private languageChange = new BehaviorSubject(null);
  languageChange$ = this.languageChange.asObservable();
  bidstatus: any;
  selectedSort: any = 'ETA_DESC';
  customText: string;
  showNomination: boolean = false;
  writeAccess: any;
  isCustomerEmulated: boolean;
  isPlaceBidDisabled: boolean;
  //lists = ["one","two","three","four"]
  constructor(
    private translation: TranslationService,
    private router: Router,
    private toastService: ToastrService,
    private customProductService: CustomProductsService,
    private cd: ChangeDetectorRef,
    private userAccountFacade: UserAccountFacade, private titleService: Title, 
    public modalService:NgbModal,
    public customloginservice:CustomLoginService,
    private csAgentAuthService:CsAgentAuthService
  ) { }
  ngOnDestroy(): void {
    this.customProductService.isShipmentPageFunction(false);
    this.shipmentPageData = [];
  }

  ngOnInit(): void {
    this.customloginservice.getASMAcess().subscribe(res=>{
      this.writeAccess = res?.writeAccess;
      this.csAgentAuthService.isCustomerEmulated().subscribe(emulated => {
        this.isCustomerEmulated = emulated;
        if(this.writeAccess==false&& this.isCustomerEmulated == true){
          this.isPlaceBidDisabled = true;
        }else{
          this.isPlaceBidDisabled = false;
        }
      })
    })
    // this.titleService.setTitle(this.Title);
    this.customProductService.getHomeLinkActive(false);
    this.translation
      .translate('breadcrumb.shipment.pageTitle')
      .subscribe(res => {
        this.title = res;
      });
    this.translation
      .translate('breadcrumb.shipment.breadcrumb')
      .subscribe(res => {
        this.navigationData = res;
      });
    this.userAccountFacade.get().subscribe((res: any) => {
      if (res) {
        //this.initialLoad();
        this.customProductService.languageChange$.subscribe(data => {
          if (data != null) {
            this.page = 0;
            this.reachedToEnd = false;
            // this.shipmentPageData = [];
            // this.customProductService.getShipmentData(this.shipmentTab, this.page, this.fromDate, this.toDate, this.status, this.commodity, this.product, this.searchText).subscribe(data => {
            //   this.shipmentPageData = data.shipmentslist;
            //   console.log('length: ' + this.shipmentPageData.length);
            //   this.enableLoader = false;
            //   this.cd.detectChanges();
            // }, err => {
            //   this.toastService.show('Something went wrong please contact support team.')
            //   this.enableLoader = false;
            // });
          }
        });
        this.customProductService.isShipmentPageFunction(true);
        this.customProductService.searchValue$.pipe(pairwise()).subscribe(([previous, current]) => {
          if (previous != current) {
            this.enableLoader = true;
            this.searchText = current;
            this.page = 0;
            this.reachedToEnd = false;
            this.shipmentPageData = [];
            this.customProductService.getShipmentData(this.shipmentTab, this.page, this.fromDate, this.toDate, this.status, this.commodity, this.product, this.searchText, this.selectedSort).subscribe(data => {
              this.shipmentPageData = data.shipmentslist;
              console.log('length: ' + this.shipmentPageData.length);
              this.enableLoader = false;
              this.cd.detectChanges();
            }, err => {
              this.toastService.show('Something went wrong please contact support team.')
              this.enableLoader = false;
            });
          }
        })
        this.customProductService.filterValues$.pipe(pairwise()).subscribe(([previous, current]) => {

          if (previous != current) {
            this.enableLoader = true;
            this.status = current.selectedStatus;
            this.product = current.selectedProduct;
            this.fromDate = current.startDate;
            this.toDate = current.endDate;
            this.commodity = current.selectedCommodity
            this.page = 0;
            this.reachedToEnd = false;
            this.shipmentPageData = [];
            this.customProductService.getShipmentData(this.shipmentTab, this.page, this.fromDate, this.toDate, this.status, this.commodity, this.product, this.searchText, this.selectedSort).subscribe(data => {
              this.shipmentPageData = data.shipmentslist;
              this.enableLoader = false;
              this.cd.detectChanges();
            }, err => {
              this.toastService.show('Something went wrong please contact support team.')
              this.enableLoader = false;
            });
          }
        })
        this.customProductService.getMessageFromBundle(this.shipmentTab).subscribe((res) => {
          this.customText = res.description;
        });
        this.customProductService.getShipstatus().subscribe((status) => {
          if (status === 'inprogress') {
            this.activeTab = 'inprogress';
            this.shipmentTab = 'INPROGRESS';
          }
          else if (status === 'completed') {
            this.activeTab = 'completed';
            this.shipmentTab = 'COMPLETED';
          }
          else {
            this.activeTab = 'upcoming';
            this.shipmentTab = 'UPCOMING';
          }
          this.customProductService.getShipmentData(this.shipmentTab, this.page, this.fromDate, this.toDate, this.status, this.commodity, this.product, this.searchText, this.selectedSort).subscribe(data => {
            this.shipmentPageData = data.shipmentslist;
            this.enableLoader = false;
            this.cd.detectChanges();
          }, err => {
            this.toastService.show('Something went wrong please contact support team.')
            this.enableLoader = false;
          });
        })
      }
    });
  }

  onScrollGrid(): any {
    if (!this.reachedToEnd) {
      //this.loaderShow = true;
      setTimeout(() => {
        this.loadNextDataInventoryList();
      }, 1000);
    }
  }
  changeTab(data, showMsg?): any {
    this.enableLoader = true;
    this.activeTab = data;
    this.page = 0;
    this.reachedToEnd = false;
    if (this.activeTab === 'upcoming') {
      this.shipmentTab = 'UPCOMING';
      // show active tab
    }
    else if (this.activeTab === 'inprogress') {
      // show completed tab
      this.shipmentTab = 'INPROGRESS';

    } else if (this.activeTab === 'completed') {
      // show completed tab
      this.shipmentTab = 'COMPLETED';
    }
    this.customProductService.getMessageFromBundle(this.shipmentTab).subscribe((res) => {
      this.customText = res.description;
    });
    this.customProductService.getShipmentData(this.shipmentTab, this.page, this.fromDate, this.toDate, this.status, this.commodity, this.product, this.searchText, this.selectedSort).subscribe(data => {
      this.shipmentPageData = data.shipmentslist;
      this.enableLoader = false;
      this.cd.detectChanges();
    },err=>{
      this.toastService.show('Something went wrong');
      this.enableLoader = false;
    });

  }
  viewGrid(): void {
    this.gridSrc = '/images/grid-view-orange.svg';
    this.listSrc = '/images/list-view.svg';
    this.grid = true;
    this.list = false;
  }
  viewList(): any {
    this.listSrc = '/images/list-view-orange.svg';
    this.gridSrc = '/images/grid-view.svg';
    this.list = true;
    this.grid = false;
  }

  loadNextDataInventoryList(): any {

    if (!this.reachedToEnd) {
      this.page += 1;
      this.customProductService.getShipmentData(this.shipmentTab, this.page, this.fromDate, this.toDate, this.status, this.commodity, this.product, this.searchText, this.selectedSort).subscribe(data => {
        if (data?.shipmentslist.length > 0) {
          this.shipmentPageData = this.shipmentPageData.concat(data.shipmentslist)
        } else {
          this.reachedToEnd = true;
        }
      })
    }
  }
  gotoDeatils(shipmentId, destination, loadPort) {
    const navigationData: NavigationExtras = {
      state: {
        shipmentId: shipmentId,
        destination: destination,
        loadPort: loadPort,
        activetab: this.activeTab
      }
    };
    localStorage.setItem("shipmentDetailsId", JSON.stringify(navigationData.state))
    this.router.navigate(['/shipment/details'], navigationData);
  }
  initialLoad() {
    this.enableLoader = true;
    this.page = 0;
    this.customProductService.getShipmentData(this.shipmentTab, this.page).subscribe(
      (data: any) => {
        if (data) {
          this.shipmentPageData = data.shipmentslist;
          //  this.shipmentProductEntriesData = data && data.shipmentslist && data.shipmentslist[0].shipmentWithProductEntries ? data.shipmentslist[0].shipmentWithProductEntries: [];
          // this.featuresData=data && data.shipmentslist && data.shipmentslist[0].shipmentWithProductEntries ? data.shipmentslist[0].shipmentWithProductEntries : [];
          this.enableLoader = false;
          this.cd.detectChanges();
        }
        else {
          this.toastService.show('Error loading this page')
        }

      },
      err => {
        this.errorMessage = err;
        this.toastService.show("Sorry something went wrong, please try again!")
        this.enableLoader = false;
      }
    );
  }
  convertDate(dateString): any {
    if (dateString) {
      return moment
        .utc(dateString)
        .local()
        .format('DD/MM/YYYY');
    } else {
      return '--';
    }
  }
  selectChangeHandler(event: any): void {
    this.selectedSort = event.target.value;
    this.page = 0;
    this.reachedToEnd = false;
    this.customProductService.getShipmentData(this.shipmentTab, this.page, this.fromDate, this.toDate, this.status, this.commodity, this.product, this.searchText, this.selectedSort).subscribe(data => {
      this.shipmentPageData = data.shipmentslist;
      this.enableLoader = false;
      this.cd.detectChanges();
    }, err => {
      this.toastService.show('Something went wrong please contact support team.')
      this.enableLoader = false;
    });
  }
  redirectTo(url: string) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([url])});
  }
  openNomination(shipmentId,vesselNominationStatus){
    const ModalRef = this.modalService.open(VesselNominationModalComponent,{centered: true,size:'lg'});
    ModalRef.componentInstance.shipmentId = shipmentId;
    ModalRef.componentInstance.vesselNominationStatus = vesselNominationStatus;
    ModalRef.componentInstance.refresh.subscribe(_=>{
      this.redirectTo('/shipment/shipmentProduct');     
    })
  }
}
